import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { vendorRegistrationStates } from '../../hooks/useVendorRegistrationHook';

const vendorRegistrationActions = mapDefaultValuesToActions(vendorRegistrationStates);

export default reduxReducerHelper(vendorRegistrationActions, vendorRegistrationStates);
